import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { firstValueFrom } from 'rxjs';
import { Filter, FilterOperation } from 'src/app/core/jsonapi/filter';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { TemplatesVariablesService } from '../../_services/templates-variables.service';
import { TemplateVariables } from '../../_types/template-variable';

@Component({
    selector: 'app-templates-variables',
    templateUrl: './templates-variables.component.html',
    styleUrls: ['./templates-variables.component.css'],
    standalone: false
})
export class TemplatesVariablesComponent implements OnInit {
  
  public loading: boolean = false;
  private lastGridEvent: any;
  private templateType?: string; 
  public filters: any = {
    templateType: new Filter(FilterOperation.equals, 'templateType')
  };

  public templateVariables: TemplateVariables[] = [];
  public totalRecords: number = 0;

  constructor(
    private config: DynamicDialogConfig,
    private templatesVariablesService: TemplatesVariablesService,
    private dynamicDialogRef: DynamicDialogRef) 
  {
  }

  ngOnInit() {
    if (this.config.data.templateType) {
      this.templateType = this.config.data.templateType;      
    }
  }

  public async loadData($event: any) {
    this.loading = true;
    this.lastGridEvent = $event;
    let params: IParamsCollection = {
      page: { number: $event.first + 1, size: $event.rows },
    }
    if (typeof $event.sortField != "undefined") params.sort = [($event.sortOrder > 0 ? "-" : "") + $event.sortField];
    this.filters.templateType.value =this.templateType; 
    //creamos filtros
    params.filter = FilterBuilder.fromObject(this.filters).build();  

    let response = await firstValueFrom(this.templatesVariablesService.all(params));
    this.templateVariables = response.data;
    this.totalRecords = response.meta['total'];
    this.loading = false;
  }

  cancel() {
    this.dynamicDialogRef.close();
  }
}
